"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckRealName = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPay_1 = require("../../model/hsPay");
var service_1 = require("../../../library/base/service");
var CheckRealName = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CheckRealName, _super);
    function CheckRealName() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验实名是否一致接口';
        _this.code = '105041';
        _this.desc = '校验实名是否一致接口';
        _this.requestParams = new hsPay_1.CheckRealNameRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CheckRealName;
}(service_1.BaseService));
exports.CheckRealName = CheckRealName;
//# sourceMappingURL=checkRealName.js.map